/**
 * «¿CÓMO SACO UN CHAT DE WHATSAPP?» (tanda 5). En la reunión del 5-oct el dueño
 * (iPhone, WhatsApp Business) no encontraba dónde se exporta un chat: la guía de
 * antes solo tenía el paso de Android. Plegable, para no tapar la subida.
 */
export function GuiaExportarChat({ abierta = false, paraEntrenar = false }: { abierta?: boolean; paraEntrenar?: boolean }) {
  return (
    <details open={abierta} className="rounded-xl border border-surface-border bg-white p-4 text-sm text-slate-600 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300">
      <summary className="min-h-[44px] cursor-pointer font-semibold text-slate-700 dark:text-slate-200">¿Cómo saco un chat de WhatsApp?</summary>
      <div className="mt-2 space-y-3">
        <div>
          <p className="font-medium text-slate-700 dark:text-slate-200">iPhone (WhatsApp o WhatsApp Business)</p>
          <ol className="list-inside list-decimal space-y-1">
            <li>Abre el chat (o el grupo)</li>
            <li>Toca el nombre del contacto, arriba</li>
            <li>
              Baja hasta <strong>Exportar chat</strong>
            </li>
            <li>
              Elige <strong>Sin archivos</strong>
            </li>
            <li>Guárdalo o mándatelo por correo, y súbelo aquí</li>
          </ol>
        </div>
        <div>
          <p className="font-medium text-slate-700 dark:text-slate-200">Android</p>
          <ol className="list-inside list-decimal space-y-1">
            <li>Abre el chat (o el grupo)</li>
            <li>Menú de los tres puntos → Más → Exportar chat</li>
            <li>
              Elige <strong>Sin archivos</strong>
            </li>
            <li>Guárdalo o mándatelo por correo, y súbelo aquí</li>
          </ol>
        </div>
        <p>Se hace uno por uno. Sin archivos pesa poco y no hace falta más.</p>
        {paraEntrenar && (
          <p>
            Para entrenar a tu agente, mándanos <strong>por lo menos 30 chats</strong>, con situaciones distintas: la pareja que compró su entrada, la que se enfrió, el que pidió todo, la marca que quiso patrocinar…
          </p>
        )}
      </div>
    </details>
  );
}
